import React from 'react';

const Hero = () => {
  const stats = [
    {
      number: '28+',
      label: 'Years Experience',
      sublabel: 'Serving Pharma Lines Since 1997',
      icon: 'fa-history',
      color: 'text-primary'
    },
    {
      number: '25+',
      label: 'Pharma Partners',
      sublabel: 'Trusted by Packaging Giants',
      icon: 'fa-handshake',
      color: 'text-success'
    },
    {
      number: '±0.005mm',
      label: 'Machining Precision',
      sublabel: 'Micro-Tolerance Standards',
      icon: 'fa-drafting-compass',
      color: 'text-info'
    },
    {
      number: '24/7',
      label: 'Breakdown Support',
      sublabel: 'Fast Emergency Repair Response',
      icon: 'fa-tools',
      color: 'text-warning'
    }
  ];

  return (
    <section id="home" className="hero-section position-relative bg-white py-4 py-lg-5 border-bottom">
      <div className="container py-lg-3">
        <div className="row align-items-stretch g-4 g-lg-5">
          {/* Hero Left: Copy & CTAs */}
          <div className="col-lg-6 text-center text-lg-start d-flex flex-column justify-content-between">
            <div>
              {/* Main Headline */}
              <h1 className="hero-title text-dark fw-bold mb-3 mt-0">
                Manufacturer of Ampoule and Vial Machineries Spare Parts & Repairing Contractors.
              </h1>

              {/* Mobile-Only Machinery Showcase (Directly below headline on mobile) */}
              <div className="d-lg-none my-3 text-center">
                <div className="machinery-card border rounded-3 p-0 shadow-xs position-relative overflow-hidden mx-auto" style={{ maxWidth: '380px', width: '100%' }}>
                  <img
                    src="/machine_rotary_hero.jpg"
                    alt="Rotary Ampoule and Vial Packaging Machinery"
                    className="img-fluid w-100"
                    style={{ maxHeight: '240px', objectFit: 'cover', objectPosition: 'center' }}
                  />
                  <div className="position-absolute bottom-0 start-0 end-0 bg-dark bg-opacity-75 text-white py-1 px-2 text-center" style={{ fontSize: '0.72rem', backdropFilter: 'blur(4px)' }}>
                    <i className="fas fa-check-circle text-success me-1"></i>
                    Rotary Ampoule & Vial Forming Machinery
                  </div>
                </div>
              </div>

              {/* Subtitle */}
              <p className="hero-description text-muted lead mb-3 mb-md-4 fs-6 mx-auto mx-lg-0" style={{ maxWidth: '520px' }}>
                Leading manufacturers and repair contractors serving India’s prominent pharmaceutical packaging plants. We engineer high-precision burners, chuck spares, shafts, SM-3 spares, and custom tooling to keep your production lines running with zero downtime.
              </p>

              {/* Key Metrics Counter Cards (Directly above the 2 buttons) */}
              <div className="hero-stats-grid mb-3 mb-md-4">
                <div className="row g-2 g-sm-2.5">
                  {stats.map((stat, idx) => (
                    <div key={idx} className="col-6 col-sm-3">
                      <div className="stat-card bg-white p-2 p-sm-2.5 rounded-3 border h-100 d-flex flex-column justify-content-center text-center shadow-2xs">
                        <div className="d-flex align-items-center justify-content-center gap-1.5 mb-1">
                          <i className={`fas ${stat.icon} ${stat.color} fs-6`}></i>
                          <div className="stat-number fw-bold text-dark fs-5 lh-1">{stat.number}</div>
                        </div>
                        <div className="stat-label fw-semibold text-dark text-xs lh-sm">{stat.label}</div>
                        <div className="stat-sublabel text-muted d-none d-sm-block mt-0.5" style={{ fontSize: '0.65rem' }}>{stat.sublabel}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Dual CTAs - Responsive: side-by-side balanced row on mobile, full-featured on desktop */}
            <div className="d-flex flex-wrap flex-sm-nowrap gap-2 justify-content-center justify-content-lg-start mb-3 mb-lg-0 hero-btn-group">
              <a
                href="#contact"
                className="btn btn-primary fw-semibold shadow-sm d-inline-flex align-items-center justify-content-center gap-1.5 rounded-2 hero-cta-btn flex-fill flex-sm-grow-0"
              >
                <i className="fas fa-file-invoice small"></i>
                <span className="text-nowrap">Request a Quote</span>
              </a>
              <a
                href="#products"
                className="btn btn-outline-dark fw-semibold d-inline-flex align-items-center justify-content-center gap-1.5 rounded-2 hero-cta-btn flex-fill flex-sm-grow-0"
              >
                <i className="fas fa-cogs small"></i>
                <span className="text-nowrap">View Spare Parts</span>
              </a>
            </div>
          </div>

          {/* Hero Right: Authentic Machinery Showcase (Desktop Only) */}
          <div className="col-lg-6 d-none d-lg-block">
            <div className="hero-image-wrapper position-relative h-100 d-flex flex-column justify-content-center">
              <div className="machinery-card border rounded-3 p-0 shadow-sm position-relative overflow-hidden d-flex align-items-center justify-content-center bg-light">
                <img
                  src="/machine_rotary_hero.jpg"
                  alt="Rotary Ampoule and Vial Forming & Packaging Machinery"
                  className="img-fluid w-100"
                  style={{ objectFit: 'cover', objectPosition: 'center', maxHeight: '480px' }}
                />
                <div className="position-absolute top-0 start-0 m-3 z-1">
                  <span className="badge bg-white text-dark border shadow-xs px-2.5 py-1.5 rounded-pill d-inline-flex align-items-center gap-1.5 fw-semibold" style={{ fontSize: '0.78rem' }}>
                    <span className="rounded-circle bg-success d-inline-block" style={{ width: '8px', height: '8px' }}></span>
                    Rotary Ampoule & Vial Forming Machinery
                  </span>
                </div>
                <div className="position-absolute bottom-0 end-0 m-3 z-1">
                  <span className="badge bg-dark bg-opacity-75 text-white px-2.5 py-1.5 rounded-2 small fw-normal d-inline-flex align-items-center gap-1.5" style={{ backdropFilter: 'blur(4px)' }}>
                    <i className="fas fa-check-circle text-success"></i>
                    <span>Custom Spares & Turret Assemblies</span>
                  </span>
                </div>
              </div>

              {/* Floating Badge 1: Heritage */}
              {/* <div className="floating-trust-badge position-absolute bg-white border shadow-sm rounded-3 p-2 d-none d-md-flex align-items-center gap-2 text-nowrap" style={{ zIndex: 10 }}>
                <div className="bg-primary text-white rounded-2 d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '38px', height: '38px' }}>
                  <i className="fas fa-award"></i>
                </div>
                <div className="text-start pe-1">
                  <div className="fw-bold small text-dark lh-sm">28+ Years</div>
                  <div className="text-muted" style={{ fontSize: '0.72rem', lineHeight: '1.2' }}>Industry Trust</div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
